import { FC, useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import * as Styles from './styles';

export interface ILogo {
  target?: number;
  rotation?: number;
}

let easedTarget = 50; // 0-100%
let easedRotation = 90; // 0-360

const targets = [25, 50, 75];
const rotations = [0, 45, 90, 135, 180, 225];

let i = 0;
export const Logo: FC<ILogo> = () => {
  const router = useRouter();

  const ref = useRef<SVGCircleElement>(null);
  const refG = useRef<SVGGElement>(null);
  const PI = Math.PI * 10;
  const rafCutoff = 0.001;
  const ease = 10;

  useEffect(() => {
    let raf: number;
    i += 1;
    const target = targets[i % targets.length]; // Math.random() * 100; // 50
    const rotation = rotations[~~(Math.random() * rotations.length - 1)]; //  Math.random() * 360; // 255

    const update = () => {
      raf = requestAnimationFrame(update);
      easedTarget += (target - easedTarget) / ease;
      easedRotation += (rotation - easedRotation) / ease;
      if (ref.current) {
        ref.current.style.strokeDasharray = `calc(${(easedTarget * PI) / 100}) ${PI}`;
      }

      if (refG.current) {
        refG.current.style.transform = `rotate(${easedRotation}deg)`;
      }

      if (Math.abs(target - easedTarget) < rafCutoff && Math.abs(rotation - easedRotation) < rafCutoff) {
        cancelAnimationFrame(raf);
      }
    };

    raf = requestAnimationFrame(update);

    return () => {
      cancelAnimationFrame(raf);
    };
  }, [PI, router?.pathname]);

  return (
    <Styles.SVG width="24" height="24" viewBox="0 0 20 20">
      <Styles.Background r="9.8" cx="10" cy="10" fill="white" />
      <Styles.G ref={refG}>
        <Styles.Circle ref={ref} r="5" cx="10" cy="10" fill="transparent" strokeWidth="10" />
      </Styles.G>
    </Styles.SVG>
  );
};

export const LogoSVG = () => {
  return (
    <Styles.SVG width="24" viewBox="0 0 850 799" fill="none">
      <Styles.Path d="M798.15 168.299C783.276 141.524 764.576 116.024 742.901 91.7992L461.128 373.572L742.901 655.77C764.576 631.545 783.276 605.621 798.15 578.846L593.302 373.572L798.15 168.299Z" />
      <Styles.Path d="M706.776 55.6745C682.551 33.5747 657.052 15.2999 630.277 4.17233e-07L425.004 205.273L219.73 4.17233e-07C192.53 15.2999 167.03 33.5747 142.805 55.6745L425.004 337.447L706.776 55.6745Z" />
      <Styles.Path d="M847.45 326.822H712.301L665.552 373.572L712.301 420.322H847.45C849.15 405.022 850 389.297 850 373.572C850 357.422 849.15 342.122 847.45 326.822Z" />
      <Styles.Path d="M0.00374997 373.574C-0.421246 490.874 41.6534 591.173 124.528 674.048C207.827 757.347 307.701 798.997 425.001 798.572C533.8 798.997 627.724 763.297 707.198 691.898L107.103 91.802C35.2784 170.851 -0.421246 264.775 0.00374997 373.574Z" />
    </Styles.SVG>
  );
};
